module.exports = __webpack_public_path__ + "assets/images/premium-features/budgeting-2edeb1.png";